// Shared elements
export const tiptextArrAll = Array.from(document.querySelectorAll('.tiptext'));

// Summary Section
export const summarySection = document.querySelector('.summary-control-row');
export const loafNum = document.querySelector('.summary-loaf-num');
export const loafMass = document.querySelector('.summary-loaf-mass');
export const loafHydration = document.querySelector('.summary-loaf-hydration');
export const summaryContainer = document.querySelector('.summary-container');
export const summaryInputsArr = Array.from(
  summaryContainer.querySelectorAll('input')
);
export const summarySaveButtons = summaryContainer.querySelectorAll(
  '.input-box-save-cta'
);
export const totalDoughMassLabel = document.querySelector('.total-dough-label');
export const endHydrationLabel = document.querySelector('.end-hydration-label');

// Input divs in summary section
export const summaryEditors = document.querySelector('.dough-summary-editors');
export const loafNumEditor = document.querySelector('.edit-num');
export const loafMassEditor = document.querySelector('.edit-mass');
export const loafHydrationEditor = document.querySelector('.edit-hydration');
export const allCancelButtonsArr = Array.from(
  document.querySelectorAll('.input-box-cancel-cta')
);
export const loafNumInput = document.querySelector('#input-loaf-num');
export const loafMassInput = document.querySelector('#input-loaf-mass');
export const loafHydrInput = document.querySelector('#input-loaf-hydration');

// Ingredients Section
export const ingredientList = document.querySelector('.ingredient-list');
export const addIngButton = document.getElementById('add-ing-button');

// Method Section
export const methodList = document.querySelector('.method-list');

// Add Ingredient Modal
export const closeIngModal = document.getElementById('btn-cancel-ingredient');
export const overlay = document.querySelector('.add-ingredient-overlay');
export const newIngName = document.getElementById('addIngName');
export const newIngQty = document.getElementById('addIngQty');
export const newIngBPct = document.getElementById('addIngBakersPct');
export const newIngTypeParent = document.querySelector('.ingredient-type-box');
export const saveIngButton = document.getElementById('cta-add-ingredient');
export const deleteIngButton = document.getElementById('cta-delete-ingredient');
